"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
const Guid_1 = __importDefault(require("./Guid"));
exports.NodeIdTypeTwoByte = 0;
exports.NodeIdTypeFourByte = 1;
exports.NodeIdTypeNumeric = 2;
exports.NodeIdTypeString = 3;
exports.NodeIdTypeGuid = 4;
exports.NodeIdTypeByteString = 5;
// https://reference.opcfoundation.org/v104/Core/docs/Part6/5.2.2/#5.2.2.9
class NodeId {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.Type = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Type, (_b !== null && _b !== void 0 ? _b : exports.NodeIdTypeTwoByte));
        this.Identifier = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Identifier, (_d !== null && _d !== void 0 ? _d : 0));
        this.Namespace = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Namespace, (_f !== null && _f !== void 0 ? _f : 0));
    }
    encode() {
        const bucket = new Bucket_1.default();
        bucket.writeUint8(this.Type);
        switch (this.type()) {
            case exports.NodeIdTypeTwoByte: {
                bucket.writeUint8(this.Identifier);
                break;
            }
            case exports.NodeIdTypeFourByte: {
                bucket.writeUint8(this.Namespace);
                bucket.writeUint16(this.Identifier);
                break;
            }
            case exports.NodeIdTypeNumeric: {
                bucket.writeUint16(this.Namespace);
                bucket.writeUint32(this.Identifier);
                break;
            }
            case exports.NodeIdTypeGuid: {
                bucket.writeUint16(this.Namespace);
                bucket.writeStruct(this.Identifier);
                break;
            }
            case exports.NodeIdTypeByteString: {
                bucket.writeUint16(this.Namespace);
                bucket.writeByteString(this.Identifier);
                break;
            }
            case exports.NodeIdTypeString: {
                bucket.writeUint16(this.Namespace);
                bucket.writeString(this.Identifier);
                break;
            }
            default:
                throw new Error(`invalid node id type ${this.Type}`);
        }
        return bucket.bytes;
    }
    decode(b, position) {
        const bucket = new Bucket_1.default(b, position);
        this.Type = bucket.readUint8();
        switch (this.type()) {
            case exports.NodeIdTypeTwoByte:
                this.Identifier = bucket.readUint8();
                return bucket.position;
            case exports.NodeIdTypeFourByte:
                this.Namespace = bucket.readUint8();
                this.Identifier = bucket.readUint16();
                return bucket.position;
            case exports.NodeIdTypeNumeric:
                this.Namespace = bucket.readUint16();
                this.Identifier = bucket.readUint32();
                return bucket.position;
            case exports.NodeIdTypeByteString:
                this.Namespace = bucket.readUint16();
                this.Identifier = bucket.readByteString();
                return bucket.position;
            case exports.NodeIdTypeString:
                this.Namespace = bucket.readUint16();
                this.Identifier = bucket.readString();
                return bucket.position;
            case exports.NodeIdTypeGuid:
                this.Namespace = bucket.readUint16();
                this.Identifier = new Guid_1.default();
                bucket.readStruct(this.Identifier);
                return bucket.position;
            default:
                throw new Error(`invalid node id type ${this.type()}`);
        }
    }
    setServerIndexFlag() {
        this.Type |= 0x40;
    }
    setNamespaceUriFlag() {
        this.Type |= 0x80;
    }
    type() {
        return this.Type & 0xf;
    }
}
exports.default = NodeId;
exports.NewTwoByteNodeId = (value) => new NodeId({
    Type: exports.NodeIdTypeTwoByte,
    Identifier: value,
    Namespace: 0
});
exports.NewFourByteNodeId = (namespace, value) => new NodeId({
    Type: exports.NodeIdTypeFourByte,
    Identifier: value,
    Namespace: namespace
});
exports.NewNumericNodeID = (namespace, id) => new NodeId({
    Type: exports.NodeIdTypeNumeric,
    Identifier: id,
    Namespace: namespace
});
exports.NewStringNodeId = (namespace, value) => new NodeId({
    Type: exports.NodeIdTypeString,
    Identifier: value,
    Namespace: namespace
});
exports.NewByteStringNodeId = (namespace, id) => new NodeId({
    Type: exports.NodeIdTypeByteString,
    Namespace: namespace,
    Identifier: id
});
